import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getAfterSelectorBackgroundContent, POINTER_HOVER_SELECTOR } from '../../util/interactiveState.js';
import { selectToken } from '../../util/tokenSelector.js';
import { propertyColorToRgbString } from '../../util/toRgbColor.js';
import { ICON_CONTAINER_CLASS } from '../FormField/Common/constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var interactiveStyle = function interactiveStyle(experiments, theme, isPlaceholder) {
  var interactiveColor = selectToken(theme.text);
  var backgroundPrimaryInteractive = selectToken(theme.background, 'product.primary');
  var textPrimaryInteractive = selectToken(theme.text, 'product.primary');
  var borderPrimaryInteractive = selectToken(theme.border, 'product.primary.strong');
  var textTertiaryInteractive = selectToken(theme.text, 'base.subtle');
  var interactiveColorRgbValue = textPrimaryInteractive && propertyColorToRgbString(textPrimaryInteractive);
  var borderPrimaryInteractiveRgbValue = borderPrimaryInteractive && propertyColorToRgbString(borderPrimaryInteractive);
  return _objectSpread(_objectSpread({
    userSelect: 'none',
    position: 'relative',
    overflow: 'hidden'
  }, getAfterSelectorBackgroundContent()), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(POINTER_HOVER_SELECTOR), {
    '&:hover:not([disabled])': _defineProperty(_defineProperty({
      color: textPrimaryInteractive,
      borderColor: interactiveColor
    }, experiments.iconsMigrationToV3 ? ".".concat(ICON_CONTAINER_CLASS, ":not(.ads-input-action)") : 'svg:not(.ads-input-action)', {
      fill: textPrimaryInteractive,
      color: textPrimaryInteractive
    }), "span", _objectSpread(_objectSpread({}, experiments.iconsMigrationToV3 ? {} : {
      fill: textPrimaryInteractive
    }), {}, {
      color: textPrimaryInteractive
    })),
    '&:hover:not([disabled]):after': {
      background: "rgba(".concat(interactiveColorRgbValue, ", 0.08)")
    }
  }), '&:focus-visible:not([disabled])', {
    outline: "1px solid ".concat(backgroundPrimaryInteractive),
    span: {
      color: !isPlaceholder && textTertiaryInteractive
    },
    '&:focus-visible:after': {
      background: "rgba(".concat(interactiveColorRgbValue, ", 0.08)")
    }
  }), '&:hover:active:not([disabled])', {
    outline: "1px solid ".concat(backgroundPrimaryInteractive),
    span: {
      color: !isPlaceholder && textTertiaryInteractive
    }
  }), '&:focus-within:not([disabled])', {
    outline: "1px solid ".concat(backgroundPrimaryInteractive)
  }), '[tabindex="0"]', {
    '&:focus-visible': {
      background: "rgba(".concat(interactiveColor, ", 0.08)"),
      outline: "4px solid rgba(".concat(borderPrimaryInteractiveRgbValue, ", 0.5)"),
      borderRadius: '4px',
      'svg *': {
        fill: textPrimaryInteractive,
        color: textPrimaryInteractive
      }
    }
  }));
};

export { interactiveStyle };
//# sourceMappingURL=searchFieldInteractiveState.js.map
